import {
  BuildingStorefrontIcon,
  ChartPieIcon,
  Cog6ToothIcon,
  CurrencyDollarIcon,
  IdentificationIcon,
  ShoppingCartIcon,
  StarIcon,
  TruckIcon,
} from "@heroicons/react/24/outline";
import SidebarOrganism from "app/components/organisms/sidebar";
import {
  default as ClientLogo,
  default as ClientLogoLandscape,
} from "img/client-logo.webp";
import { useState } from "react";

const navigations = [
  // {
  //   id: 'dashboard',
  //   label: 'Dashboard',
  //   icon: HomeIcon,
  //   href: '/dashboard',
  // },
  {
    id: "contacts",
    label: "Kontak",
    icon: IdentificationIcon,
    href: "/customer",
    children: [
      {
        id: "customer",
        label: "Customer",
        href: "/customer",
      },
      {
        id: "supplier",
        label: "Supplier",
        href: "/supplier",
      },
    ],
  },
  {
    id: "product",
    label: "Produk",
    href: "/product",
    icon: StarIcon,
  },
  {
    id: "sales",
    label: "Penjualan",
    icon: CurrencyDollarIcon,
    children: [
      {
        id: "order",
        label: "Sales Order",
        href: "/sales_order",
      },
      {
        id: "invoice",
        label: "Sales Invoice",
        href: "/invoice",
      },
      // {
      //   id: "edit-request",
      //   label: "Edit Request",
      //   href: "/sales_order/edit_request",
      // },
      {
        id: "product_queue_grid",
        label: "Antrian Produk",
        href: "/sales_order/antrian_produk_grid",
      },
      {
        id: "product_queue",
        label: "Antrian (Tabel)",
        href: "/sales_order/antrian_produk",
      },
    ],
  },
  {
    id: "purchase",
    label: "Pembelian",
    icon: ShoppingCartIcon,
    href: "/purchase_order",
  },
  {
    id: "warehouse",
    label: "Gudang",
    icon: TruckIcon,
    children: [
      {
        id: "receive",
        label: "Penerimaan",
        href: "/receive_order",
      },
      {
        id: "order-belum-dibeli",
        label: "Order Belum Dibeli",
        href: "/delivery/order_belum_dibeli",
      },
      {
        id: "packing",
        label: "Packing",
        href: "/packing_order",
      },
      {
        id: "delivery",
        label: "Kirim",
        href: "/delivery",
      },
      {
        id: "delivery_order",
        label: "Semua Pengiriman",
        href: "/delivery_order",
      },
      {
        id: "stock_opname",
        label: "Stock Opname",
        href: "/stock-opname",
      },
      {
        id: "warehouse-transfer",
        label: "Transfer Gudang",
        href: "/warehouse-transfer",
      },
      {
        id: "scrap",
        label: "Scrap",
        href: "/scrap",
      },
      {
        id: "retur-supplier",
        label: "Retur Supplier",
        href: "/retur-supplier",
      },
      {
        id: "retur-customer",
        label: "Retur Customer",
        href: "/retur-customer",
      },
    ],
  },

  {
    id: "report",
    label: "Report",
    icon: ChartPieIcon,
    children: [
      {
        id: "daily-omzet",
        label: "Omzet",
        href: "/report/daily-omzet",
      },
      {
        id: "top-customer",
        label: "Top Customers",
        href: "/report/top-customer",
      },
      {
        id: "top-sales",
        label: "Top Sales",
        href: "/report/top-sales",
      },
      {
        id: "top-product",
        label: "Top Product",
        href: "/report/top-product",
      },
      {
        id: "top-supplier",
        label: "Top Supplier",
        href: "/report/top-supplier",
      },
      {
        id: "stock-warehouse",
        label: "Stok per Gudang",
        href: "/report/stock-warehouse",
      },
      {
        id: "warehouse-in-out",
        label: "Keluar-Masuk Gudang Utama",
        href: "/report/warehouse-in-out",
      },
      {
        id: "payment",
        label: "Pembayaran",
        href: "/report/payment",
      },
      // {
      //   id: "credit-recap",
      //   label: "Kredit Rekap",
      //   href: "/report/credit-recap",
      // },
      // {
      //   id: "credit-history",
      //   label: "Kredit Histori",
      //   href: "/report/credit-history",
      // },
    ],
  },
  {
    id: "store-report",
    label: "Laporan Toko",
    icon: BuildingStorefrontIcon,
    children: [
      {
        id: "transactions",
        label: "Transaksi",
        href: "/store-report/transactions",
      },
      {
        id: "sales-totals",
        label: "Total Penjualan",
        href: "/store-report/sales-totals",
      },
      {
        id: "membership",
        label: "Membership",
        href: "/store-report/membership",
      },
      {
        id: "outlet-stock",
        label: "Stok Outlet",
        href: "/store-report/outlet-stock",
      },
      {
        id: "stock-mutation",
        label: "Mutasi Stok Outlet",
        href: "/store-report/stock-mutation",
      },
      {
        id: "sales-by-product",
        label: "Penjualan per Produk",
        href: "/store-report/sales-by-product",
      },
      {
        id: "sales-by-category",
        label: "Penjualan per Kategori",
        href: "/store-report/sales-by-category",
      },
      {
        id: "sales-by-cashier",
        label: "Penjualan per Kasir",
        href: "/store-report/sales-by-cashier",
      },
      {
        id: "sales-by-payment-method",
        label: "Penjualan per Metode Bayar",
        href: "/store-report/sales-by-payment-method",
      },
      {
        id: "daily-closing",
        label: "Closing Kasir Harian",
        href: "/store-report/daily-closing",
      },
    ],
  },
  {
    id: "settings",
    label: "Settings",
    icon: Cog6ToothIcon,
    children: [
      {
        id: "color-variant",
        label: "Varian Warna",
        href: "/color-variant",
      },
      {
        id: "size-variant",
        label: "Varian Size",
        href: "/size-variant",
      },
      {
        id: "category",
        label: "Kategori",
        href: "/category",
      },
    ],
  },
  // {
  //   id: "auth",
  //   label: "User",
  //   icon: UsersIcon,
  //   children: [
  //     {
  //       id: "user",
  //       label: "Daftar User",
  //       href: "/user",
  //     },
  //     {
  //       id: "role",
  //       label: "Roles & Permission",
  //       href: "/role",
  //     },
  //   ],
  // },
];

function AgnosticSidebar({ activeNavigation, activeChild }) {
  const sidebarLogo = {
    image: ClientLogoLandscape,
    collapsedImage: ClientLogo,
    imageAlt: process.env.REACT_APP_CLIENT_NAME,
    collapsedImageAlt: process.env.REACT_APP_CLIENT_NAME,
  };

  const calculateNavigations = (navigations) => {
    const calculatedNavigations = navigations.map((navigation) => {
      const active = navigation.id === activeNavigation;
      navigation.active = active;

      if (navigation.children) {
        navigation.expanded = active;
        navigation.children = navigation.children.map((child) => {
          child.active = child.id === activeChild;
          return child;
        });
      }

      return navigation;
    });
    return calculatedNavigations;
  };

  const [calculatedNavigations, setCalculatedNavigations] = useState(
    calculateNavigations(navigations)
  );

  const handleOnChange = (newCalculatedNavigations) => {
    setCalculatedNavigations(newCalculatedNavigations);
  };

  return (
    <SidebarOrganism
      sidebarLogo={sidebarLogo}
      navigations={calculatedNavigations}
      onChange={handleOnChange}
    />
  );
}

export default AgnosticSidebar;
